import stations from './baihedongFireStations.json';
import './tiandituFireStations.scss';

const VIEW_EVENTS = ['moveend', 'zoomend', 'resize'];

// 微消站独立维护，不参与单位轮询、单位详情和烟感筛选。
export default {
  data () {
    return { fireStationLayers: [], activeFireStation: null, hoveredFireStation: null };
  },
  methods: {
    bindFireStationEvents () {
      VIEW_EVENTS.forEach(event => this.bindMapEvent(this.map, event, this.updateFireStationVisibility));
    },
    // 只在白鹤洞单位主图创建一次，保留 Excel 原始 GCJ02 数值，由地图入口转换为展示坐标。
    syncFireStations () {
      if (!this.isMapReady()) return;
      if (!this.isBaihedongOverview() || this.smokeBuildings !== null) {
        this.clearFireStations();
        return;
      }
      if (!this.fireStationLayers.length) {
        stations.forEach(station => {
          const point = this.getMapPoint(station);
          const marker = new window.T.Marker(point, {
            icon: new window.T.Icon({
              iconUrl: '/monitor/images/bdmap/marker_micro_fire_station.svg',
              iconSize: [44, 50],
              iconAnchor: [22, 47]
            })
          });
          const title = document.createElement('span');
          title.textContent = `${station.name} · 微消站`;
          const label = new window.T.Label({
            text: title.innerHTML,
            position: point,
            offset: this.getTiandituLabelOffset(0, -57),
            className: 'tianditu-fire-station-label'
          });
          this.map.addLayer(marker);
          this.map.addLayer(label);
          const entry = { station, marker, label };
          this.fireStationLayers.push(entry);
          label.getElement().style.display = 'none';
          this.bindMapEvent(marker, 'mouseover', () => {
            this.hoveredFireStation = entry;
            if (this.activeFireStation !== entry) this.showFireStationLabel(entry, false);
          });
          this.bindMapEvent(marker, 'mouseout', () => {
            if (this.hoveredFireStation === entry) this.hoveredFireStation = null;
            if (this.activeFireStation !== entry) label.getElement().style.display = 'none';
            this.scheduleAutoUnitLabels();
          });
          this.bindMapEvent(marker, 'click', () => {
            const previous = this.activeFireStation;
            if (previous) previous.label.getElement().style.display = 'none';
            this.activeFireStation = previous === entry ? null : entry;
            if (this.activeFireStation) this.showFireStationLabel(entry, true);
            this.scheduleAutoUnitLabels();
          });
        });
      }
      this.updateFireStationVisibility();
    },
    // 用 textContent 写入表格资料，避免将场所名称或备注解释为 HTML。
    showFireStationLabel (entry, detail) {
      const content = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = `${entry.station.name} · 微消站`;
      content.appendChild(title);
      if (detail) {
        const station = entry.station;
        [
          ['社区位置', station.community],
          ['负责人', `${station.contact} ${station.phone}`],
          ['网格员', `${station.gridContact} ${station.gridPhone}`],
          ['备注', station.remark]
        ].forEach(([name, value]) => {
          if (!value) return;
          const row = document.createElement('div');
          row.textContent = `${name}：${value}`;
          content.appendChild(row);
        });
      }
      entry.label.setLabel(content.innerHTML);
      const element = entry.label.getElement();
      element.style.display = '';
      // 通过 SDK 偏移定位，保留标签根节点用于地图投影的 transform。
      // 先显示再测量，名称和详情均居中放在图标上方，底部保持 10px 间距。
      entry.label.setOffset(this.getTiandituLabelOffset(
        -element.offsetWidth / 2, -57 - element.offsetHeight
      ));
      this.scheduleAutoUnitLabels();
    },
    updateFireStationVisibility () {
      if (!this.isMapReady()) return;
      const visible = this.map.getZoom() >= this.labelOverviewZoom;
      this.fireStationLayers.forEach(entry => {
        entry.marker.getElement().style.display = visible ? '' : 'none';
        // 视野更新保留正在悬浮或已点击的标签，不将悬浮状态当成未选中而清除。
        if (!visible || (this.activeFireStation !== entry && this.hoveredFireStation !== entry)) {
          entry.label.getElement().style.display = 'none';
        }
      });
      if (!visible) {
        this.activeFireStation = null;
        this.hoveredFireStation = null;
      }
      this.scheduleAutoUnitLabels();
    },
    clearFireStations () {
      this.fireStationLayers.forEach(({ marker, label }) => {
        this.map.removeLayer(marker);
        this.map.removeLayer(label);
      });
      this.fireStationLayers = [];
      this.activeFireStation = null;
      this.hoveredFireStation = null;
    }
  },
  beforeDestroy () {
    if (!this.map) return;
    VIEW_EVENTS.forEach(event => this.map.removeEventListener(event, this.updateFireStationVisibility));
    this.clearFireStations();
  }
};
